// Centralized testid constants
export const TID = {
  // Nav
  navLogo: "nav-logo",
  navServices: "nav-services-link",
  navReviews: "nav-reviews-link",
  navQuote: "nav-quote-link",
  navContact: "nav-contact-link",
  navCta: "nav-cta-button",
  navMobileToggle: "nav-mobile-toggle",
  // Hero
  heroCta: "hero-quote-cta",
  heroCall: "hero-call-cta",
  // Referral
  referralBanner: "referral-banner",
  referralCta: "referral-cta",
  // Services
  serviceCommercial: "service-commercial",
  serviceMoveinout: "service-moveinout",
  servicePostconstruction: "service-postconstruction",
  // Quote form
  qfName: "qf-name",
  qfEmail: "qf-email",
  qfPhone: "qf-phone",
  qfServiceType: "qf-service-type",
  qfPropertyType: "qf-property-type",
  qfSqft: "qf-sqft",
  qfAddress: "qf-address",
  qfDate: "qf-date",
  qfMessage: "qf-message",
  qfUpload: "qf-image-upload",
  qfUploadInput: "qf-image-upload-input",
  qfSubmit: "qf-submit",
  qfSuccess: "qf-success",
  // Reviews
  reviewsList: "reviews-list",
  reviewAddBtn: "review-add-btn",
  reviewName: "review-name",
  reviewRating: "review-rating",
  reviewTitle: "review-title",
  reviewBody: "review-body",
  reviewSubmit: "review-submit",
  // Chat
  chatToggle: "chat-toggle",
  chatWindow: "chat-window",
  chatStartName: "chat-start-name",
  chatStartEmail: "chat-start-email",
  chatStartBtn: "chat-start-btn",
  chatInput: "chat-input",
  chatSend: "chat-send",
  chatMessages: "chat-messages",
  // Admin
  adminLoginEmail: "admin-login-email",
  adminLoginPassword: "admin-login-password",
  adminLoginSubmit: "admin-login-submit",
  adminLogout: "admin-logout",
  adminTabRequests: "admin-tab-requests",
  adminTabReviews: "admin-tab-reviews",
  adminTabChats: "admin-tab-chats",
  adminRequestsList: "admin-requests-list",
  adminViewRequest: "admin-view-request",
  adminQuoteAmount: "admin-quote-amount",
  adminQuoteScope: "admin-quote-scope",
  adminQuoteNotes: "admin-quote-notes",
  adminQuoteSubmit: "admin-quote-submit",
  adminApproveReview: "admin-approve-review",
  adminRejectReview: "admin-reject-review",
};
